let pendingImportFile: File | null = null;

export function setPendingImportFile(file: File): void {
  pendingImportFile = file;
}

export function takePendingImportFile(): File | null {
  const file = pendingImportFile;
  pendingImportFile = null;
  return file;
}
